import { useEffect } from "react";
import { useAnnouncementsStore } from "@/features/admin/store/announcements-store";
import { useAuthStore } from "@/features/auth/store/auth-store";

/**
 * Subscribe to the firm-readable announcements (What's New popup + broadcast
 * banner + events/resources), short-polled from a single shared store. Replaces
 * the legacy WebSocket push with polling (§12). Only firm accounts consume it —
 * individual/portal users never start the poll.
 */
export function useAnnouncements() {
  const isFirmAccount = useAuthStore(
    (s) => s.isAuthenticated && s.user?.account_type === "firm",
  );
  const announcements = useAnnouncementsStore((s) => s.announcements);
  const acquire = useAnnouncementsStore((s) => s.acquire);
  const release = useAnnouncementsStore((s) => s.release);
  const refresh = useAnnouncementsStore((s) => s.refresh);

  useEffect(() => {
    if (!isFirmAccount) return;
    acquire();
    return () => release();
  }, [isFirmAccount, acquire, release]);

  return { announcements: isFirmAccount ? announcements : null, refresh };
}
